import * as React from 'react';
import { IFieldConfig } from '../../../../interface/field-config.interface';
import { FieldTextAreaStateless } from '@atlaskit/field-text-area';
import { FieldTextStateless } from '@atlaskit/field-text';
import { FieldsEnum } from '../../../../enum/fields.enum';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../../interface/component/injected-props.interface';
import styled from 'styled-components';
import { BlockColorEnum } from '../../../../enum/block-color.enum';
import {action, observable} from 'mobx';

interface InputFieldProps {
  onChange: any;
  onBlur: any;
  multiline?: boolean;
  value: string;
  isValid?: boolean;
  invalidityMessage?: React.ReactNode;
  labelColor: string;
}

const inputFieldType: {
  [key in FieldsEnum]?: string;
} = {
  [ FieldsEnum.INPUT ]: 'text',
  [ FieldsEnum.URL ]: 'text',
  [ FieldsEnum.SSN ]: 'ssn',
  [ FieldsEnum.ZIP ]: 'zip',
  [ FieldsEnum.EMAIL ]: 'email',
  [ FieldsEnum.PHONE ]: 'phone'
};
const FieldComponentWrapper = styled.div`
  position: relative;
  & label div {
    color: ${(props: { labelColor: string }) => props.labelColor} !important;
  }
  & input {
    height: 36px;
    background: ${BlockColorEnum.SecondaryTextColor};
  }
  & div div div {
    background: ${BlockColorEnum.SecondaryTextColor};
  }
  & div div div:hover {
    background: ${BlockColorEnum.SecondaryTextColor};
  }
  & textarea {
    height: 132px;
    background: ${BlockColorEnum.SecondaryTextColor};
  }
`;

const FieldCharacterCount = styled.div`
  position: absolute;
  bottom: -20px;
  right: 0;
  pointer-events: none;
  opacity: ${(props: {isVisible: boolean}) => props.isVisible ? 1 : 0};
  transition: opacity 500ms;
  display: flex;
  flex-direction: row-reverse;
`;

const CountContainer = styled.span`
  color: ${(props: {isExceeded: boolean}) => props.isExceeded ? BlockColorEnum.ErrorColor : BlockColorEnum.InactiveColor};
`;

@inject('state')
@observer
export class InputField extends React.Component<IFieldConfig & InputFieldProps & IInjectedProps> {
  @observable focused: boolean = false;

  @action
  onFocus = () => this.focused = true

  @action
  onBlur = () => {
    this.focused = false;
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  render() {
    const props = this.props;
    const maxLength = props.maxChars !== 0 ? props.maxChars : undefined;
    let FieldComponent = FieldTextStateless;
    if (props.multiline) {
      FieldComponent = FieldTextAreaStateless;
    }
    return (
        <FieldComponentWrapper labelColor={props.labelColor}>
          <FieldComponent
              disabled={props.disabled}
              label={props.label}
              placeholder={props.placeholder}
              name={props.applyFormKey}
              type={inputFieldType[props.type]}
              shouldFitContainer={true}
              required={props.required}
              isInvalid={!props.isValid}
              value={props.value}
              invalidMessage={props.invalidityMessage}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={(event: any) => !props.onChange ? undefined : props.onChange(event.target.value)}
          />
          <FieldCharacterCount isVisible={this.focused && Boolean(maxLength) && Boolean(props.value)}>
            <CountContainer isExceeded={false}>&nbsp;{`/${maxLength}`}</CountContainer>
            <CountContainer isExceeded={maxLength && Boolean(props.value) && props.value.length > maxLength}>{Boolean(props.value) ? props.value.length : '0'}</CountContainer>
          </FieldCharacterCount>
        </FieldComponentWrapper>
    );
  }
}
